import { atom } from 'jotai';

import type { AssetGroup } from '@/types/asset';

/**
 * Asset to run through the normal download flow from *outside* a download
 * button. Set by the DialogStage's returning-user login (DEV-6514) so that,
 * once the user is authenticated, the standard ConfirmDownload popup — or its
 * upsell, if they still can't download the asset — opens for the asset they
 * came for, instead of a bespoke DialogStage screen.
 *
 * A single globally-mounted `GlobalDownloadModal` consumes this: it copies the
 * asset into local state and clears the atom, so the atom is a fire-and-forget
 * signal rather than the modal's lifecycle owner.
 */
export const globalDownloadAssetAtom = atom<AssetGroup | null>(null);
